import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import classnames from 'classnames';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import DeleteIcon from '@material-ui/icons/Delete';
import SaveIcon from '@material-ui/icons/Save';
import CancelIcon from '@material-ui/icons/CancelOutlined';
import TextField from '@material-ui/core/TextField';
import DataTable from './shared/DataTable';
import Typography from '@material-ui/core/Typography';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {observer} from "mobx-react";
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';

const styles = theme => ({
    button: {
        margin: theme.spacing.unit,
    },
    leftIcon: {
        marginRight: theme.spacing.unit,
    },
    rightIcon: {
        marginLeft: theme.spacing.unit,
    },
    iconSmall: {
        fontSize: 20,
    },
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: 170
    },
    warningButton: {
        margin: theme.spacing.unit,
        color: "white",
        backgroundColor: "#E9190F",
        '&:hover': {
            backgroundColor: "#E9190F",
        },
    },
    appBar: {
        backgroundColor: 'white',
        top: 'auto',
        bottom: 0,
    }
});

class ClientDetails extends Component
{

    constructor(props)
    {
        super(props);
        this.tableColumns = [
            {name: "Auftragsnummer", field: "orderid", sortable: false},
            {name: "Produkt", field: "product_name", sortable: false},
            {name: "Kopien", field: "copies", sortable: false},
            {name: "Einheiten", field: "units", sortable: false},
            {name: "Sticker (Einzigartig)", field: "unique_stickers", sortable: false},
            {name: "Sticker (Gesamt)", field: "total_stickers", sortable: false},
        ]
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSafetyCheckInputChange = this.handleSafetyCheckInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.toggleModal = this.toggleModal.bind(this);

        this.state = {
            deleteModal: false,
            safetyCheckWord: '',
            safetyCheckPassed: false
        }
    }

    toggleModal()
    {
        this.setState({
            deleteModal: !this.state.deleteModal,
        });
    }

    handleSafetyCheckInputChange(event)
    {
        const target = event.target;
        const value = target.value;
        this.setState({safetyCheckWord: value})
        if (value === this.props.clientStore.client.customerid)
        {
            this.setState({safetyCheckPassed: true})
        } else
        {
            this.setState({safetyCheckPassed: false})
        }
    }

    handleInputChange(event)
    {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.props.clientStore.client[name] = value;
    }

    handleSubmit(event)
    {
        this.props.clientStore.saveClient(this.props.match.params.id);
        event.preventDefault();
    }

    deleteClient()
    {
        this.props.clientStore.deleteClient(this.props.match.params.id);
    }

    componentDidMount()
    {
        this.props.clientStore.getClient(this.props.match.params.id);
    }

    render()
    {
        const {classes} = this.props;

        return (
            <div>
                <ToastContainer/>
                <Dialog
                    open={this.state.deleteModal}
                    onClose={this.toggleModal}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">Kunde löschen</DialogTitle>
                    <DialogContent>
                        Um den Kunden <strong>{this.props.clientStore.client.company}</strong> endgültig zu löschen, bestätige den Vorgang durch Eingabe der
                        Kundennummer <strong>{this.props.clientStore.client.customerid}</strong>.
                        <br/>
                        <TextField
                            id="customerid"
                            name="customerid"
                            label="Kundennummer"
                            className={classes.textField}
                            value={this.state.safetyCheckWord}
                            onChange={this.handleSafetyCheckInputChange}
                            margin="normal"
                            InputLabelProps={{shrink: true}}
                            fullWidth={true}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button variant="contained" size="small" color="primary" onClick={this.toggleModal} className={classes.button}>
                            <CancelIcon className={classnames(classes.leftIcon, classes.iconSmall)}/>
                            Abbrechen
                        </Button>
                        <Button variant="contained" size="small" color="secondary" onClick={() => this.deleteClient()} className={classes.warningButton}
                                disabled={!this.state.safetyCheckPassed}>
                            <DeleteIcon className={classnames(classes.leftIcon, classes.iconSmall)}/>
                            Löschen
                        </Button>
                    </DialogActions>
                </Dialog>
                <Typography variant="title" gutterBottom>
                    Kundennummer: {this.props.clientStore.client.customerid}
                </Typography>
                <form noValidate autoComplete="off">
                    <Grid container spacing={16}>
                        <Grid item>
                            <TextField
                                id="company"
                                name="company"
                                label="Firma"
                                className={classes.textField}
                                value={this.props.clientStore.client.company || ''}
                                onChange={this.handleInputChange}
                                margin="normal"
                                InputLabelProps={{shrink: true}}
                            />
                            <br/>
                            <TextField
                                id="lastname"
                                name="lastname"
                                label="Nachname"
                                className={classes.textField}
                                value={this.props.clientStore.client.lastname || ''}
                                onChange={this.handleInputChange}
                                margin="normal"
                                InputLabelProps={{shrink: true}}
                            />
                            <br/>
                            <TextField
                                id="firstname"
                                name="firstname"
                                label="Vorname"
                                className={classes.textField}
                                value={this.props.clientStore.client.firstname || ''}
                                onChange={this.handleInputChange}
                                margin="normal"
                                InputLabelProps={{shrink: true}}
                            />
                        </Grid>
                        <Grid item>
                            <TextField
                                id="street"
                                name="street"
                                label="Straße"
                                className={classes.textField}
                                value={this.props.clientStore.client.street || ''}
                                onChange={this.handleInputChange}
                                margin="normal"
                                InputLabelProps={{shrink: true}}
                            />
                            <br/>
                            <TextField
                                id="postalcode"
                                name="postalcode"
                                label="Postleitzahl"
                                className={classes.textField}
                                value={this.props.clientStore.client.postalcode || ''}
                                onChange={this.handleInputChange}
                                margin="normal"
                                InputLabelProps={{shrink: true}}
                            />
                            <br/>
                            <TextField
                                id="city"
                                name="city"
                                label="Stadt"
                                className={classes.textField}
                                value={this.props.clientStore.client.city || ''}
                                onChange={this.handleInputChange}
                                margin="normal"
                                InputLabelProps={{shrink: true}}
                            />
                        </Grid>
                        <Grid item>
                            <TextField
                                id="country"
                                name="country"
                                label="Land"
                                className={classes.textField}
                                value={this.props.clientStore.client.country || ''}
                                onChange={this.handleInputChange}
                                margin="normal"
                                InputLabelProps={{shrink: true}}
                            />
                            <br/>
                            <TextField
                                id="phone"
                                name="phone"
                                label="Telefon"
                                className={classes.textField}
                                value={this.props.clientStore.client.phone || ''}
                                onChange={this.handleInputChange}
                                margin="normal"
                                InputLabelProps={{shrink: true}}
                            />
                            <br/>
                            <TextField
                                id="mobile"
                                name="mobile"
                                label="Handy"
                                className={classes.textField}
                                value={this.props.clientStore.client.mobile || ''}
                                onChange={this.handleInputChange}
                                margin="normal"
                                InputLabelProps={{shrink: true}}
                            />
                        </Grid>
                        <Grid item>
                            <TextField
                                id="email"
                                name="email"
                                label="E-Mail"
                                className={classes.textField}
                                value={this.props.clientStore.client.email || ''}
                                onChange={this.handleInputChange}
                                margin="normal"
                                InputLabelProps={{shrink: true}}
                            />
                            <br/>
                            <TextField
                                id="created_by"
                                label="Erstellt von"
                                className={classes.textField}
                                value={this.props.clientStore.client.created_by || ''}
                                margin="normal"
                                InputLabelProps={{shrink: true}}
                                onClick={() =>
                                {
                                    (this.props.clientStore.client.created_by && this.props.clientStore.client.created_by !== '') ?
                                        this.props.history.push("/users/" + this.props.clientStore.client.created_by) : alert("Keine gültige Benutzerkennung")
                                }}
                                disabled
                            />
                            <br/>
                            <TextField
                                id="updated_by"
                                label="Zuletzt bearbeitet von"
                                className={classes.textField}
                                value={this.props.clientStore.client.updated_by || ''}
                                margin="normal"
                                InputLabelProps={{shrink: true}}
                                onClick={() =>
                                {
                                    (this.props.clientStore.client.updated_by && this.props.clientStore.client.updated_by !== '') ?
                                        this.props.history.push("/users/" + this.props.clientStore.client.updated_by) : alert("Keine gültige Benutzerkennung")
                                }}
                                disabled
                            />
                        </Grid>
                    </Grid>
                    <hr/>
                    <Typography variant="subheading" gutterBottom>
                        Aufträge
                    </Typography>
                    <Grid container spacing={16}>
                        <DataTable
                            store={this.props.clientStore}
                            detailRoute="/orders"
                            rows={this.props.clientStore.client.orderList}
                            columns={this.tableColumns}
                            history={this.props.history}
                        />
                    </Grid>
                    <AppBar position="fixed" color="primary" className={classes.appBar}>
                        <Toolbar>
                            <Grid
                                container
                                direction="row"
                                justify="flex-end"
                                alignItems="flex-start">
                                <Grid item>
                                    <Button variant="contained" size="small" color="default" onClick={() => this.toggleModal()}
                                            className={classes.warningButton}>
                                        <DeleteIcon className={classnames(classes.leftIcon, classes.iconSmall)}/>
                                        Löschen
                                    </Button>
                                </Grid>
                                <Grid item>
                                    <Button variant="contained" size="small" color="secondary" onClick={this.handleSubmit.bind(this)}
                                            className={classes.button}>
                                        <SaveIcon className={classnames(classes.leftIcon, classes.iconSmall)}/>
                                        Speichern
                                    </Button>
                                </Grid>
                            </Grid>
                            <div className={classes.grow}/>
                        </Toolbar>
                    </AppBar>
                </form>
            </div>
        );
    }
}

export default withStyles(styles)(observer(ClientDetails));
